<template>
  <div class="contact-service-component">
    <div
      class="contact-service"
      @click="contactService"
    >
      <img class="icon-contact-service" src="./img/icon_contact_service.png" />
    </div>
  </div>
</template>

<script>
export default {
  computed: {
    clientWidth () {
      return document.documentElement.clientWidth;
    }
  },
  methods: {
    contactService () {
      const boxSize = 720;
      const screenX = (this.clientWidth / 2) - (boxSize / 2);
      const left = screenX > 0 ? screenX : 500;
      window.open(
        'https://webchat-bj.clink.cn/chat.html?accessId=9b2af095-b970-4b55-8455-53eb4b91d1c9&language=zh_CN',
        '_blank',
        `scrollbars=yes,resizable=1,location=false,menubar=false,modal=false,alwaysRaised=yes,width=${boxSize},height=${boxSize},left=${left},top=100`
      );
    }
  }
};
</script>

<style scoped>
.contact-service-component {
  position: fixed;
  right: 20px;
  bottom: 200px;
  cursor: pointer;
  .icon-contact-service {
    width: 100px;
    height: 79px;
  }
}
</style>



// WEBPACK FOOTER //
// src/projects/hsbpc/views/welcome/components/contact-service.vue